import { useState, useCallback } from 'react';
import { modulesAPI } from '../../services/api/modules';
import { useApi } from './useApi';

export function useModules() {
  const [modules, setModules] = useState([]);
  const [currentModule, setCurrentModule] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchAllModules = useCallback(async () => {
    const result = await execute(() => modulesAPI.getAllModules());
    if (result.success) {
      setModules(result.data.modules || []);
    }
    return result;
  }, [execute]);

  const fetchModuleById = useCallback(async (moduleId) => {
    const result = await execute(() => modulesAPI.getModuleById(moduleId));
    if (result.success) {
      setCurrentModule(result.data);
    }
    return result;
  }, [execute]);

  const getModulePermissions = useCallback(async (moduleId) => {
    return await execute(() => modulesAPI.getModulePermissions(moduleId));
  }, [execute]);

  return {
    modules,
    currentModule,
    loading,
    error,
    clearError,
    fetchAllModules,
    fetchModuleById,
    getModulePermissions,
  };
}